import { useState } from 'react'

import { SortableContainer, SortableElement } from 'react-sortable-hoc'
import arrayMove from 'array-move'

import { JSONFetcher, formatCents, PopoverIcon } from 'shared'

import { EditButton } from './edit_button'
import { ExternalDonationButton } from './external_donation_button'

const SortableItem = SortableElement((props) => {

  return <li className='generic-draggable p-2' style={{ display: props.completed ? 'none' : 'block' }}>
    <i className='fa fa-bars grip-handle' />
    <strong>{props.name}</strong>
    <div>{I18n.t('modules.need_editor.still_needed_html', { amount: formatCents(props.stillNeededAmount) })}</div>

    <div className='flex items-center mt-2 mr-12' style={{ flexWrap: 'wrap' }}>
      {props.editable ?
        <div className='flex' style={{ flexWrap: 'wrap' }}>
          {props.editDeUrl && <EditButton locale='de' {...props} />}
          {props.editEnUrl && <EditButton locale='en' {...props} />}
        </div> :
        <span className='simulated-link text-gray-700 hover:text-gray-700 whitespace-nowrap desktop:mr-2'>
          {I18n.t("modules.need_editor.edit_button")} <PopoverIcon popover={I18n.t('modules.need_editor.edit_disabled_tooltip')} />
        </span>
      }
      <button className='simulated-link whitespace-nowrap desktop:mr-2 p-0' onClick={() => {
        JSONFetcher.post({
          url: props.duplicateUrl,
          success: () => window.location.reload()
        })
      }}>{I18n.t("modules.need_editor.duplicate_button")}</button>

      <div className='desktop:mr-2'>
        <ExternalDonationButton {...props} /> <PopoverIcon popover={I18n.t('modules.need_editor.external_donation_tooltip')} />
      </div>

      {props.deletable && <button className='simulated-link text-gray-700 hover:text-gray-700 font-weight-400' onClick={() => {
        if (window.confirm(I18n.t('misc.are_you_sure_dialogue'))) {
          JSONFetcher.delete({
            url: props.deleteUrl,
            success: () => window.location.reload()
          })
        }
      }}>
        <i className="fa fa-trash-alt fa-xs mr-1"></i>
        {I18n.t("modules.need_editor.delete_button")}
      </button>}

      {!props.deletable && <span className='text-gray-300 font-weight-400'>
        <i className="fa fa-trash-alt fa-xs mr-1"></i>
        <span className='cursor-not-allowed line-through mr-1'>
          {I18n.t('modules.need_editor.delete_button')}
        </span>
        <PopoverIcon popover={I18n.t('modules.need_editor.delete_disabled_tooltip')} />
      </span>}

    </div>
  </li>
})

const SortableList = SortableContainer(({ needs }) => {
  return (
    <ol className='list-unstyled'>
      {needs.map((need, index) => (
        <SortableItem key={`need-${need.id}`} index={index} {...need} />
      ))}
    </ol>
  )
})

export const NeedEditor = (props) => {
  const [needs, setNeeds] = useState(JSON.parse(props.needs))

  const onSortEnd = ({ oldIndex, newIndex }) => {
    JSONFetcher.post({
      url: needs[oldIndex].moveUrl,
      body: { position: newIndex },
      success: (response) => { },
      error: (response) => { console.log('sorting failed', response) },
    })
    setNeeds(arrayMove(needs, oldIndex, newIndex))
  }

  return <SortableList needs={needs} onSortEnd={onSortEnd} distance={10} lockAxis='y' />
}
